export default __webpack_public_path__ + "static/media/CV2.afd55730.pdf";